<div class="customer-details-panel vstack gap-3">
    <div class="customer-details-card vstack gap-2 gap-lg-3">
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Customer Name
            </span>
            <div class="col-md-9">
                <app-input
                    #customerName
                    [isEditable]="true"
                    [placeholder]="'Customer Name'"
                    [readonlyValue]="customer.name().length === 0 ? 'None' : customer.name()"
                    [initialValue]="customer.name()"
                    [inputType]="InputType.Text"
                    [validators]="customerNameValidators"
                    (inputSubmitted)="updateName($event)"
                >
                </app-input>
            </div>
        </div>
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Email Address
            </span>
            <div class="hstack align-items-center justify-content-between col-md-9">
                <app-input
                    #emailAddress
                    [isEditable]="true"
                    [placeholder]="'None'"
                    [readonlyValue]="customer.emailAddress ?? 'None'"
                    [initialValue]="customer.emailAddress"
                    [inputType]="InputType.Email"
                    [validators]="emailAddressValidators"
                    (inputSubmitted)="updateEmailAddress($event)"
                >
                </app-input>
            </div>
        </div>
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Phone
            </span>
            <div class="col-md-9">
                <app-input
                    #phoneNumber
                    [isEditable]="true"
                    [placeholder]="'Phone Number'"
                    [readonlyValue]="customer.phoneNumber ? (customer.phoneNumber | phoneNumber) : 'None'"
                    [initialValue]="customer.phoneNumber"
                    [inputType]="InputType.Tel"
                    [validators]="phoneNumberValidators"
                    (inputSubmitted)="updatePhoneNumber($event)"
                >
                </app-input>
            </div>
        </div>
        <hr class="m-0"/>
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Aliases
            </span>
            <div class="col-md-9 vstack gap-2">
                    <div
                        *ngFor="let alias of customer.emailAddressAliases; let i = index"
                        class="d-flex align-items-center gap-2"
                    >
                        <span class="text-muted">{{ alias }}</span>
                        <button
                            type="button"
                            class="btn btn-link btn-sm text-danger p-0"
                            (click)="removeEmailAlias(i)"
                            [disabled]="isEditing"
                            [attr.aria-label]="'Remove email alias ' + alias"
                        >
                            <i class="bi bi-x-circle" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div *ngIf="!isAddingAlias" class="mt-1">
                        <button
                            type="button"
                            class="btn btn-link btn-sm p-0"
                            (click)="startAddingAlias()"
                            [disabled]="isEditing"
                        >
                            <i class="bi bi-plus-circle me-1"></i>
                            Add email address alias
                        </button>
                    </div>
                    <div *ngIf="isAddingAlias" class="d-flex align-items-center gap-2 mt-1">
                        <label class="visually-hidden" for="customer-email-alias">
                            Email address alias
                        </label>
                        <input
                            id="customer-email-alias"
                            type="email"
                            class="form-control"
                            placeholder="email@example.com"
                            [(ngModel)]="newEmailAlias"
                            [disabled]="isEditing"
                            (keyup.enter)="addEmailAlias()"
                            (keyup.escape)="cancelAddingAlias()"
                        />
                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            (click)="addEmailAlias()"
                            [disabled]="isEditing || !newEmailAlias"
                        >
                            Add
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-secondary"
                            (click)="cancelAddingAlias()"
                            [disabled]="isEditing"
                        >
                            Cancel
                        </button>
                    </div>
                <span class="form-text">
                    Alternative email addresses associated with this customer.
                </span>
            </div>
        </div>
    </div>

    <div class="customer-details-card vstack gap-2 gap-lg-3">
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Customer Note
            </span>
            <div class="col-md-9 vstack gap-1">
                <app-textarea
                    #note
                    style="display: contents;"
                    [placeholder]="'Add a Customer Note'"
                    [isEditable]="true"
                    [initialValue]="customer.note()"
                    [rows]="3"
                    (textSubmitted)="updateNote($event)"
                >
                </app-textarea>
                <span class="form-text">
                    Customer Notes are private to you, and appear on any bookings linked to this customer.
                </span>
            </div>
        </div>
        <hr class="m-0"/>
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Food & Drink Preferences
            </span>
            <div class="col-md-9 vstack gap-1">
                <app-textarea
                    #foodDrinkPreferences
                    style="display: contents;"
                    [placeholder]="'Add Food & Drink Preferences'"
                    [isEditable]="true"
                    [initialValue]="customer.foodDrinkPreferences"
                    [rows]="3"
                    (textSubmitted)="updateFoodDrinkPreferences($event)"
                >
                </app-textarea>
                <span class="form-text">
                    Record any dietary requirements, allergies, or food and drink preferences.
                </span>
            </div>
        </div>
    </div>

    <div class="customer-details-card vstack gap-2 gap-lg-3">
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Customer Status
            </span>
            <div class="col-md-9 vstack gap-1">
                <div
                    class="btn-group segmented-control flex-fill-equally"
                    role="group"
                >
                    <input
                        type="radio"
                        class="btn-check"
                        id="standard-status"
                        autocomplete="off"
                        [checked]="!customer.vip"
                        [disabled]="isEditing"
                        (change)="updateVipStatus(false)"
                    >
                    <label
                        class="btn btn-outline-primary btn-sm"
                        for="standard-status"
                        data-testid="standard-status"
                    >
                        Standard
                    </label>
                    <input
                        type="radio"
                        class="btn-check"
                        id="vip-status"
                        autocomplete="off"
                        [checked]="customer.vip"
                        [disabled]="isEditing"
                        (change)="updateVipStatus(true)"
                    >
                    <label
                        class="btn btn-outline-primary btn-sm"
                        for="vip-status"
                        data-testid="vip-status"
                    >
                        VIP Customer
                    </label>
                </div>
                <span class="form-text">
                    Mark important customers as VIPs to provide special attention.
                </span>
            </div>
        </div>
        <hr class="m-0"/>
        <div class="row align-items-baseline">
            <span class="col-md-3 py-2">
                Feedback Requests
            </span>
            <div class="col-md-9 vstack gap-1">
                <div class="form-check form-switch hstack gap-2 align-items-center">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="send-feedback-request"
                        [checked]="customer.sendFeedbackRequest"
                        [disabled]="isEditing"
                        (change)="updateSendFeedbackRequest(!customer.sendFeedbackRequest)"
                    >
                    <label
                        class="form-check-label"
                        for="send-feedback-request"
                        data-testid="send-feedback-request"
                    >
                        {{ customer.sendFeedbackRequest ? 'Enabled' : 'Disabled' }}
                    </label>
                </div>
                <span class="form-text">
                    When disabled, matching future bookings will not receive customer feedback request emails unless the option is manually enabled on the booking.
                </span>
            </div>
        </div>
        <hr class="m-0"/>
        <div
            class="row align-items-baseline"
            data-testid="barred-setting"
        >
            <span
                class="col-md-3 py-2 hstack gap-2 billing-entitlement-action-group"
                data-testid="barred-entitlement"
                [appBillingEntitlement]="Entitlement.CustomerAcceptanceCustomisation"
            >
                Barred
            </span>
            <div class="col-md-9 vstack gap-1">
                <div class="form-check form-switch hstack gap-2 align-items-center">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="barred-status"
                        [checked]="customer.barred"
                        [disabled]="isEditing || (Entitlement.CustomerAcceptanceCustomisation | hasBillingEntitlement | async) !== true"
                        (change)="updateBarredStatus(!customer.barred)"
                    >
                    <label
                        class="form-check-label"
                        for="barred-status"
                        data-testid="barred-status"
                    >
                        {{ customer.barred ? 'Barred' : 'Not barred' }}
                    </label>
                </div>
                <span class="form-text">
                    Barred customers cannot make bookings online using their email address or phone number.
                </span>
            </div>
        </div>
        <hr class="m-0"/>
        <div
            class="row align-items-baseline"
            data-testid="skip-card-capture-setting"
        >
            <span
                class="col-md-3 py-2 hstack gap-2 billing-entitlement-action-group"
                data-testid="skip-card-capture-entitlement"
                [appBillingEntitlement]="Entitlement.CustomerAcceptanceCustomisation"
            >
                Skip Card Capture
            </span>
            <div class="col-md-9 vstack gap-1">
                <div class="form-check form-switch hstack gap-2 align-items-center">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        id="card-details-not-required"
                        [checked]="customer.cardDetailsNotRequired"
                        [disabled]="isEditing || (Entitlement.CustomerAcceptanceCustomisation | hasBillingEntitlement | async) !== true"
                        (change)="updateCardDetailsNotRequired(!customer.cardDetailsNotRequired)"
                    >
                    <label
                        class="form-check-label"
                        for="card-details-not-required"
                        data-testid="card-details-not-required"
                    >
                        {{ customer.cardDetailsNotRequired ? 'Skipped' : 'Required' }}
                    </label>
                </div>
                <span class="form-text">
                    When enabled, this customer does not have to provide card details at the time of booking, even if a cancellation policy is active.
                </span>
            </div>
        </div>
        <hr class="m-0"/>
        <div
            class="row align-items-baseline"
            data-testid="required-deposit-setting"
        >
            <span
                class="col-md-3 py-2 hstack gap-2 billing-entitlement-action-group"
                data-testid="required-deposit-entitlement"
                [appBillingEntitlement]="Entitlement.CustomerAcceptanceCustomisation"
            >
                Required Deposit
            </span>
            <div class="col-md-9 vstack gap-1">
                <div class="input-group customer-details__deposit-input">
                    <span class="input-group-text">£</span>
                    <input
                        type="number"
                        class="form-control"
                        id="deposit-amount"
                        data-testid="deposit-amount"
                        placeholder="None"
                        step="0.01"
                        min="0"
                        [value]="customer.depositAmount !== null ? (customer.depositAmount / 100).toFixed(2) : ''"
                        [disabled]="isEditing || (Entitlement.CustomerAcceptanceCustomisation | hasBillingEntitlement | async) !== true"
                        (change)="updateDepositAmount($any($event.target).value)"
                    >
                    <span class="input-group-text">per cover</span>
                </div>
                <span class="form-text">
                    When set, this customer must pay this deposit per cover when their booking doesn't normally require payment.
                </span>
            </div>
        </div>
    </div>
</div>
